import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { useState } from "react";
import { IoMdCheckmark, IoMdCopy } from 'react-icons/io';
import { CopyButton } from "./styles";

export default function LinkInformationModal({ open, link, onClose }) {
  const [hasCopied, setHasCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      setHasCopied(true);

      await navigator.clipboard.writeText(link);
    } catch(error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setHasCopied(false);
      }, 800);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Informações sobre o link de pagamento</DialogTitle>
      <DialogContent>
          <span><strong>Link</strong>: <a href={link} target="_blank">{link}</a></span>
      </DialogContent>
      <DialogActions>
        <CopyButton hasCopied={hasCopied} onClick={handleCopyLink}>
          {hasCopied ? (
            <>
              <IoMdCheckmark size="1.25em" />
              <span>Link copiado</span>
            </>
          ) : (
            <>
              <IoMdCopy size="1.25em" />
              <span>Copiar Link</span>
            </>
          )}
        </CopyButton>
      </DialogActions>
    </Dialog>
  )
}